import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
//hocs
import { useAuth } from "../../hoc/UseAuth";
import { useMenu } from "../../hoc/MenuContext";
//utils
import { useScrollPosition } from '../../utils/scroll'
import { SMenu } from '../../utils/svgs'
//parts
import { MenuItem } from './Item'

import m from "./menu.module.scss";
import { QUERY_BRANDSLUG } from '../../lib/Queries';

export const Menu = () => {
    const navigate = useNavigate();
    // O estado "open" vive no MenuContext (no topo da árvore). Antes era
    // state local do Menu — e como o Menu é remontado quando a rota muda
    // (Home → seção), o open voltava a false no meio do clique. Isso
    // explicava "menu fecha sem deixar clicar".
    const { open, setOpen, toggle, close, openItem, handleOpenItem } = useMenu();
    const scrollY = useScrollPosition();
    const auth = useAuth();
    const menuRef = useRef<HTMLDivElement>(null);

    const sections = QUERY_BRANDSLUG()?.sections;


    // Fecha o menu quando clica fora. Compara pelo ref — assim não depende
    // da hash do CSS Module nem de .closest() casar com classe específica.
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            const node = menuRef.current;
            if (!node) return;
            const target = e.target as Node | null;
            if (target && !node.contains(target)) {
                close();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [close]);

    const handleLogout = async () => {
        try {
            await auth.logout();
            console.log("Logout bem-sucedido");
            navigate("/signin");
            // Aqui você pode realizar outras ações após o logout bem-sucedido, se necessário
        } catch (error) {
            console.error("Erro ao fazer logout:", error);
        }
    }

    return (
        <div className={`${open ? m.active : ''} ${m.bu_menu}`}
            style={{
                maxHeight: scrollY >= 110 ? "100vh" : "calc(100vh - 110px)",
                marginTop: scrollY >= 110 ? 0 : 110,
            }}
            ref={menuRef}
        >
            <div className={m.top_menu}>
                <div className={m.action_menu}>
                    <div className={m.icon_menu} onClick={toggle}>
                        <SMenu color={'#000000'} active={open} />
                    </div>
                </div>
                <div className={m.items}>
                    <MenuItem
                        name={'Home'}
                        link={'/'}
                    />
                    {sections?.map((s: any, i: number) => {
                        return (
                            <MenuItem
                                key={i}
                                name={s.name}
                                slug={s.slug}
                                link={`/s/${s.slug}/${s.modules && s.modules[0]?.id}`}
                                sub_section={s.subsections}
                                modules={s.modules}
                                openItem={openItem === s.slug}
                                handleOpenItem={handleOpenItem}
                            />
                        )
                    })}
                    <MenuItem
                        name={'Downloads'}
                        link={'/downloads'}
                    />
                </div>
            </div>
            <div className={m.bottom_menu}>
                <div className={m.logout_menu} onClick={() => handleLogout()}>
                    <p>Logout</p>
                </div>
            </div>
        </div>
    )
}
